import { DataUtils, UrlUtils } from "../../../../utils";
import { config as defaultConfig } from "../../default/Spectate/Config.resource";

const getSportUrl = () => {
  return UrlUtils.getCurrentOriginURLWithLang(window.location.origin);
};

export const links = {
  betFeed: "/betfeed/",
  bettingHistory: "/bets/b/",
  bettingRules: "/getting-started/betting-rules/",
  blog: "/blog/",
  contactUs: `https://888-external-en.custhelp.com/app/home/p/243/`,
  help: "http://www.888.com/help/app/home/p/243/",
  home: "/",
  liveChat:
    "https://888-external-en.custhelp.com/app/chat/chat_launch?chanel=888sport_en_norm&ChRefId=3",
  liveChatVIP:
    "https://888-external-en.custhelp.com/app/chat/chat_launch?chanel=888sport_en_vip&ChRefId=1",
  liveNow: "/live-betting/",
  pokerHistoryLink: "/app/poker-history/",
  promotions: "/promotions/",
  promotionsVIP: "/vip-sports-betting/current.htm",
  recommendations: "/recommendations/",
  madeForYou: {
    en: "/madeforyou/fortoday/mfytoday/"
  },
  responsibleGaming: `/security-privacy/patron-protection/`,
  sportUrl: getSportUrl(),
  casinoUrl: "http://casino.sisportsbook.com/",
  casinoNativeUrl: "https://si-casino.onelink.me/faPi/CrossSellSportToCasino",
  startingSoon: "/starting-soon/",
  survey: DataUtils.getDataStoreValue("SurveyData")?.SurveyPage,
  legalSportsBetting: "https://www.sisportsbook.com/legal-sports-betting/",
  siCom: "https://www.si.com/",
  siShop: "https://sishop.com/",
  siTickets: "https://sitickets.com/"
};

export const config = {
  ...defaultConfig,
  logo: "logo-SI-desktop-red-white",
  logoMobile: "logo-SI-mobile-header-white",
  logoAlt: "logo-SI-mobile-header-white"
};
